import script from "./UserFollowDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFollowDataTable.vue?vue&type=script&setup=true&lang=js"

import "./UserFollowDataTable.vue?vue&type=style&index=0&id=17741de2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17741de2"]])

export default __exports__